<template>
  <Layout>
    <PageHeader :items="items"> </PageHeader>
    <div class="container-app">
      <div class="content-title">
        <span class="title-card-app">Informe Caracterización Ciudadano</span>
        <span>
          <router-link
            size="sm"
            class="p-0 ml-2 btn-link-add"
            :to="{ name: 'home' }"
          >
            <b-icon class="icon-plus" icon="arrow90deg-left"></b-icon>
          </router-link>
        </span>
      </div>
      <b-overlay
        :show="isBusy"
        blur="5px"
        :opacity="1"
        variant="transparent"
        spinner-variant="primary"
        spinner-type="grow"
        rounded="sm"
      >
        <div class="row">
          <div class="col-md-12">
            <div class="col-md-12 col-lg-12 col-xl-12 card-app mb-3">
              <div class="row">
                <div
                  class="col-lg-6 col-md-6 col-12"
                  v-for="(variable, index) in search_variables"
                  :key="`prev-dim--base-${index}-${variable.id}`"
                >
                  <renderVariable
                    :variable="variable"
                    :isComponent="false"
                    :isPreview="false"
                  />
                </div>
                <div class="col-12 d-flex justify-content-end">
                  <b-button variant="primary" pill @click.prevent="getReport()"
                    >Consultar</b-button
                  >
                  <b-button
                    variant="outline-primary"
                    pill
                    @click.prevent="generateReport"
                    class="ml-1"
                    :disabled="search_results.length == 0 || isBusyPDF"
                  >
                    <i class="far fa-file-pdf"></i> Descarga
                  </b-button>
                </div>
              </div>
            </div>
            <div
              class="col-md-12 col-lg-12 col-xl-12 card-app mb-3"
              v-if="search_results.length > 0"
            >
              <VueHtml2pdf
                :show-layout="true"
                :float-layout="false"
                :enable-download="false"
                :preview-modal="false"
                :pdf-quality="2"
                pdf-format="a3"
                pdf-orientation="landscape"
                pdf-content-width="100%"
                :paginate-elements-by-height="1100"
                :manual-pagination="false"
                :html-to-pdf-options="htmlToPdfOptions"
                @progress="onProgress($event)"
                @startPagination="startPagination()"
                @hasPaginated="hasPaginated()"
                @beforeDownload="beforeDownload($event)"
                @hasDownloaded="hasDownloaded($event)"
                ref="html2Pdf"
              >
                <section slot="pdf-content" class="table-responsive">
                  <!-- PDF Content Here -->
                  <table
                    class="
                    table
                    b-table
                    table-sm
                    m-0
                    w-100
                    pdf-item
                    table-striped
                  "
                  >
                    <thead>
                      <tr>
                        <th colspan="2">Dimensión</th>
                        <th>Variable</th>
                        <th>Respuesta</th>
                      </tr>
                    </thead>
                    <tbody
                      v-for="dimension in search_results"
                      :key="dimension.id"
                    >
                      <tr
                        v-for="(answer, row) in dimension.DATA"
                        :key="answer.id"
                        v-show="answer.FORSESDET_VALOR"
                      >
                        <td
                          v-if="row === 0"
                          nowrap="nowrap"
                          :rowspan="dimension.DATA.length"
                          class="align-top"
                        >
                          <b>{{ dimension.FORSESDET_DIMENSION_NOMBRE }}</b></td
                        >
                        <td></td>
                        <td>{{ answer.FORSESDET_VARIABLE_ETIQUETA }}</td>
                        <td>{{
                          answer.FORSESDET_VARIABLE_TIPO === 'boolean'
                            ? answer.FORSESDET_VALOR === 'True'
                              ? 'Verdadero'
                              : 'Falso'
                            : answer.FORSESDET_VALOR
                        }}</td>
                      </tr>
                    </tbody>
                  </table>
                </section>
              </VueHtml2pdf>
              <div class="d-flex justify-content-end">
                <b-button
                  @click="showDetails"
                  variant="primary"
                  pill
                  class="button-footer-1"
                  >{{
                    openDetail ? 'Ocultar detalle' : 'Ver detalle'
                  }}</b-button
                >
              </div>
            </div>
            <div
              class="col-md-12 col-lg-12 col-xl-12 card-app"
              v-if="search_results.length > 0"
            >
              <div class="row">
                <div class="col">
                  <div v-if="dataFamilies.count > 0">
                    <h6 class="title-card-app"
                      >Hogares<br />
                      <small class="text-muted">
                        Asociados a la consulta
                      </small></h6
                    >
                    <div class="accordion" role="tablist">
                      <b-card
                        no-body
                        class="mb-1"
                        v-for="(family, key) in dataFamilies.results"
                        :key="`fam-${family.id}-${key}`"
                      >
                        <b-card-header
                          header-tag="header"
                          class="p-1"
                          role="tab"
                        >
                          <b-row
                            align-v="center"
                            class="row-family"
                            v-b-toggle="`accordion-fam-${family.id}`"
                          >
                            <b-col cols="1" class="radio-family"
                              ><b-form-radio
                                v-model="selectCodHogar"
                                name="código_familia"
                                :value="family.codigoFamilia"
                              ></b-form-radio
                            ></b-col>
                            <input-multi-select
                              class="inputCodFamilie"
                              cols="3"
                            >
                              Código de Hogar:
                              <span class="spanInfoFamilie">{{
                                family.codigoFamilia
                              }}</span>
                              <br />
                              Dirección:
                              <span class="spanInfoFamilie">{{
                                family.direccion
                              }}</span>
                            </input-multi-select>
                            <b-col togle sm class="text-right"
                              ><span style="color: rgb(242, 140, 2)"
                                >({{
                                  family.personas.length
                                }}
                                Integrantes)</span
                              ></b-col
                            >
                            <b-icon
                              align-v="center"
                              class="when-closed"
                              icon="chevron-down"
                              aria-hidden="true"
                              variant="info"
                              font-scale="1"
                            ></b-icon>
                            <b-icon
                              align-v="center"
                              class="when-opened"
                              icon="chevron-up"
                              aria-hidden="true"
                              variant="info"
                              font-scale="1"
                            ></b-icon>
                          </b-row>
                        </b-card-header>

                        <b-collapse
                          v-if="family.personas.length !== 0"
                          :id="`accordion-fam-${family.id}`"
                          accordion="my-accordion"
                          role="tabpanel"
                        >
                          <b-card-body class="family-tree">
                            <b>Integrantes</b>
                            <b-list-group flush>
                              <b-list-group-item
                                v-for="(integrante, key) in family.personas"
                                :key="
                                  `int-${family.id}-${integrante.id}-${key}`
                                "
                              >
                                <b>{{ key }}</b> -
                                {{
                                  camelcase(
                                    integrante.nombres
                                      ? integrante.nombres
                                      : 'Sin Nombres'
                                  )
                                }}
                                <router-link
                                  tag="a"
                                  :to="
                                    `/informe-ciudadano/${integrante.tipoid}/${
                                      integrante.numeroid
                                    }`
                                  "
                                >
                                  <b-icon
                                    icon="exclamation-circle"
                                    style="color: #2b85d1; scale: 1.3"
                                    class="float-right button-search"
                                    size="sm"
                                    variant="outline-info"
                                    pill
                                  >
                                  </b-icon>
                                </router-link>
                              </b-list-group-item>
                            </b-list-group>
                          </b-card-body>
                        </b-collapse>
                      </b-card>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="col-md-12 col-lg-12 col-xl-12 card-app">
              <div class="box-card-search">
                <div class="overlay-card-search">
                  <span class="content-icon">
                    <i class="fas fa-exclamation-triangle"></i>
                  </span>
                  <span class="title-card-search"
                    >No se encontraron datos en la búsqueda</span
                  >
                  <span class="subtitle-card-search"
                    >Realiza una nueva consulta</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-overlay>
    </div>
    <b-modal
      v-model="answerDetailModal"
      title="Detalle"
      size="xl"
      class="p-0"
      ok-only
      ok-title="Cerrar"
    >
      <table
        sidth="100%"
        class="
          table
          b-table
          table-sm
          m-0
          w-100
          table-responsive
          pdf-item
          table-striped
        "
      >
        <thead>
          <tr>
            <th>Fuente</th>
            <th>Formulario</th>
            <th>Secretaría(s)</th>
            <th>Proyecto</th>
            <th>Variable</th>
            <th>Respuesta</th>
            <th>Fecha</th>
          </tr>
        </thead>
        <tbody
          v-for="dimension in search_results"
          :key="dimension.id"
          class="html2pdf__page-break"
        >
          <tr
            v-for="answer in dimension.DATA"
            :key="answer.id"
            v-show="answer.FORSESDET_VALOR"
          >
            <td nowrap="nowrap">{{ answer.FORSESDET_FUENTE }}</td>
            <td nowrap="nowrap">{{
              getFormTitle(answer.FORSES_FK_FORM_ID)
            }}</td>
            <td nowrap="nowrap">{{
              getSecretaryName(answer.FORSES_FK_FORM_ID)
            }}</td>
            <td nowrap="nowrap">{{
              getProjectName(answer.FORSES_FK_FORM_ID)
            }}</td>
            <td nowrap="nowrap">{{ answer.FORSESDET_VARIABLE_ETIQUETA }}</td>
            <td>{{
              typeof answer.FORSESDET_VALOR_JSON === 'object'
                ? Object(answer.FORSESDET_VALOR_JSON).hasOwnProperty('value')
                  ? answer.FORSESDET_VALOR_JSON.value
                  : Array.isArray(answer.FORSESDET_VALOR_JSON)
                  ? answer.FORSESDET_VALOR_JSON.map((x) => x.value).join(', ')
                  : answer.FORSESDET_VALOR
                : answer.FORSESDET_VARIABLE_TIPO === 'boolean'
                ? answer.FORSESDET_VALOR === 'True'
                  ? 'Verdadero'
                  : 'Falso'
                : answer.FORSESDET_VALOR
            }}</td>
            <td nowrap="nowrap">{{ answer.META.modified_at.substr(0, 16) }}</td>
          </tr>
        </tbody>
      </table>
    </b-modal>
  </Layout>
</template>
<script>
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import {
  authComputed,
  variablesMethods,
  reportsMethods,
  formMethods,
  familiesMethods,
} from '@state/helpers'
import RenderVariable from '@views/variables/renderVariable.vue'
import VueHtml2pdf from 'vue-html2pdf'
import Vue from 'vue'
Vue.use(VueHtml2pdf)
export default {
  page: {
    title: 'Reporte por ciudadano',
  },
  components: { Layout, PageHeader, RenderVariable, VueHtml2pdf },
  data() {
    return {
      items: [
        {
          text: '/',
          path: '/home',
          to: { name: 'home' },
        },
        {
          text: 'Reporte por ciudadano',
          active: true,
        },
      ],
      dataFamilies: [],
      search_variables: [],
      search_results: [],
      total_results: null,
      isBusy: false,
      forms: [],
      secretaries: [],
      projects: [],
      isBusyPDF: false,
      answerDetailModal: false,
      answerSelected: {},
      openDetail: false,
    }
  },

  mounted() {
    this.getVariablesData()
    this.getForms({ query: '?list=true&page_size=999' }).then((x) => {
      this.forms = x.results
    })
    this.getSecretaries('?page_size=999').then((x) => {
      this.secretaries = x.results
    })
    this.getProjects('?page_size=999').then((x) => {
      this.projects = x.results
    })
    const nid = this.$route.params.numeroid
    const tid = this.$route.params.tipoid
    if (nid && tid) this.getReport(nid, tid)
  },
  methods: {
    ...variablesMethods,
    ...formMethods,
    ...reportsMethods,
    ...familiesMethods,

    camelcase(string) {
      let capitalize = (str) => {
        return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()
      }
      const caps = string
        .split(' ')
        .map(capitalize)
        .join(' ')
      return caps
    },

    getVariablesData() {
      this.isBusy = true
      const promise = this.getVariables(
        '?page=1&page_size=10&state=A&ordering=order&is_index=True',
        null
      )
      let _ = this
      return promise
        .then((data) => {
          this.isBusy = false
          this.search_variables = data.results.map((x) => {
            return { ...x, value: null, extra_config: { required: true } }
          })
          return data
        })
        .catch((error) => {
          this.isBusy = false
          // console.log('Se presento un error en la carga de las variables.',error)
        })
    },
    getReport(nid = null, tid = null) {
      let findPersonFields = {}
      if (nid && tid) {
        findPersonFields.tid = tid
        findPersonFields.nid = nid
      } else {
        this.search_variables
          .filter(
            (x) =>
              (Object(x.value).hasOwnProperty('key')
                ? x.value.key
                : x.value) !== null
          )
          .map((x) => {
            if (x.id == 55 && x.value)
              Object.assign(findPersonFields, { nid: x.value })
            else if (x.value)
              Object.assign(findPersonFields, { tid: x.value.key })
          })
      }
      const payload = findPersonFields

      if (payload.hasOwnProperty('tid') && payload.hasOwnProperty('nid')) {
        const promise = this.getReportByIndexVars(payload)
        let _ = this
        return promise
          .then((x) => JSON.parse(JSON.stringify(x)))
          .then((data) => {
            this.isBusy = false
            if (data.status !== 200) {
              _.search_results = []
              _.total_results = null
            } else {
              _.search_results = data.results
              _.total_results = data.count
              _.getSearchFamilies(data.results[0].FORSES_INDICE)
            }
          })
          .catch((error) => {
            this.$swal({
              title: 'Atención',
              html: 'La cedula no existe o la cedula no está registrada',
              confirmButtonText: 'Aceptar',
              showCloseButton: true,
              width: '500px',
              customClass: {
              title: 'text-' + 'warning',
              confirmButton: 'btn btn-primary rounded-pill order-2',
              cancelButton: 'btn bg-white text-dark rounded-pill order-1',
              },
              showClass: {
                backdrop: 'swal2-backdrop-show swal2-backdrop-' + 'warning',
              },
            });
            this.search_results = []
            this.total_results = null
            this.isBusy = false
            // console.log('Se presento un error en el resultado de la consulta.',error)
          })
      }
    },

    /// PDF:
    onProgress(progress) {
      // this.progressPDF = progress;
      // console.log(`PDF generation progress: ${progress}%`)
    },
    startPagination() {
      this.isBusyPDF = true
      // console.log(`PDF has started pagination`)
    },
    hasPaginated() {
      this.isBusyPDF = false
      // console.log(`PDF has been paginated`)
    },
    async beforeDownload({ html2pdf, options, pdfContent }) {
      // console.log(`On Before PDF Generation`)
      let usuario = this.getUser.username
      let fecha = new Date().toLocaleString('es-CO', { dateStyle: 'medium' })
      let hora = new Date().toLocaleString('es-CO', {
        hour: 'numeric',
        hour12: true,
        minute: 'numeric',
      })

      await html2pdf()
        .set(options)
        .from(pdfContent)
        .toPdf()
        .get('pdf')
        .then((pdf) => {
          const totalPages = pdf.internal.getNumberOfPages()
          for (let i = 1; i <= totalPages; i++) {
            pdf.setPage(i)
            pdf.setFontSize(10)
            pdf.setTextColor(150)
            let height = pdf.internal.pageSize.getHeight() - 0.3
            pdf.text(
              `Usuario: ${usuario} - Fecha: ${fecha} - Hora: ${hora}`,
              0.3,
              height
            )
            pdf.text(
              `Página ${i} de ${totalPages}`,
              pdf.internal.pageSize.getWidth() * 0.88,
              height
            )
          }
        })
        .save()
    },
    hasDownloaded(blobPdf) {
      // console.log(`PDF has downloaded`)
      this.isBusyPDF = false
      // console.log(blobPdf)
    },
    domRendered() {
      // console.log("Dom Has Rendered");
    },

    async generateReport() {
      // console.log("generateReport")

      this.$refs['html2Pdf'].generatePdf()
    },

    getFormTitle(form_id) {
      try {
        return this.forms.filter(
          (x) => parseFloat(x.id) === parseFloat(form_id)
        )[0].title
      } catch (error) {
        return form_id
      }
    },
    getSecretaryName(form_id) {
      let _ = this
      try {
        return _.secretaries
          .filter((y) =>
            _.forms
              .filter((x) => parseFloat(x.id) === parseFloat(form_id))[0]
              .secretaries.find((z) => z === y.id)
          )
          .map((z) => {
            return z.name
          })
          .join(',\n')
      } catch (error) {
        return ''
      }
    },
    getProjectName(form_id) {
      let _ = this
      try {
        return _.projects.filter(
          (y) =>
            _.forms.filter((x) => parseFloat(x.id) === parseFloat(form_id))[0]
              .project === y.id
        )[0].name
      } catch (error) {
        return 'N/A'
      }
    },
    showDetails() {
      this.answerDetailModal = true
    },
    async getSearchFamilies(idpersona) {
      try {
        const response = await this.getFamiliesByPersonId({
          PersonId: idpersona,
        })
        if (response) {
          if (response.count > 0) {
            this.dataFamilies = response
          } else {
            this.dataFamilies = []
          }
        } else {
          this.dataFamilies = []
        }
      } catch (error) {}
    },
  },

  computed: {
    ...authComputed,
    getUser: function() {
      return this.$store.state.auth.currentSession
        ? this.$store.state.auth.currentSession.user
        : []
    },
    htmlToPdfOptions() {
      return {
        margin: 0.3,
        filename: `${Date.now()}.pdf`,
        image: {
          type: 'jpeg',
          quality: 1,
        },
        enableLinks: true,
        html2canvas: {
          scale: 1,
          useCORS: true,
        },
        jsPDF: {
          unit: 'in',
          format: 'a4',
          orientation: 'portrait',
        },
        pagebreak: { after: '.page-break' },
      }
    },
  },
  watch: {
    search_variables: {
      deep: true,
      handler(newValue, oldValue) {
        this.total_results = null
      },
    },
  },
}
</script>

<style lang="scss">
.table .align-top {
  vertical-align: top !important;
}
</style>
